import { Box, Stack } from '@mui/material';
import { useLayoutEffect, useRef, useState, type PropsWithChildren } from 'react';
import { HoldContext } from './use-hold-login-column';

/** The column's distance from the top of its centring parent, taken as a hold begins. */
const useHeldTop = (holding: boolean) => {
  const ref = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState<number>();

  useLayoutEffect(() => {
    const parent = ref.current?.parentElement;
    if (!holding || !ref.current || !parent) return setTop(undefined);
    setTop(ref.current.getBoundingClientRect().top - parent.getBoundingClientRect().top);
  }, [holding]);

  return { ref, top: holding ? top : undefined };
};

/**
 * Centred by its parent, but pinned where it stands while an error shows, so the error pushes
 * only what is below it down. The space under it absorbs the growth; past that, the page grows.
 */
export const LoginColumn = ({ children }: PropsWithChildren) => {
  const [holds, setHolds] = useState(0);
  const { ref, top } = useHeldTop(holds > 0);

  return (
    <HoldContext.Provider value={setHolds}>
      <Box
        ref={ref}
        sx={{ width: '100%', ...(top !== undefined && { mt: `${top}px`, mb: 'auto' }) }}
      >
        <Stack sx={{ width: '100%', alignItems: 'center', gap: 1 }}>{children}</Stack>
      </Box>
    </HoldContext.Provider>
  );
};
